import PropTypes from "prop-types";
import React from "react";

class Timeline extends React.Component {
  static get displayName() {
    return "Timeline";
  }

  static get propTypes() {
    return {
      children: PropTypes.node,
    };
  }

  render() {
    return <ul className="timeline">{this.props.children}</ul>;
  }
}

class Separator extends React.Component {
  static get displayName() {
    return "TimelineSeparator";
  }

  static get propTypes() {
    return {
      color: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    };
  }

  render() {
    return (
      <li className="time-label">
        <span className={`bg-${this.props.color}`}>{this.props.text}</span>
      </li>
    );
  }
}

class Item extends React.Component {
  static get displayName() {
    return "TimelineItem";
  }

  static get propTypes() {
    return {
      color: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      time: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      content: PropTypes.node,
    };
  }

  render() {
    return (
      <li className="timeline-container">
        <i className={`fa fa-${this.props.icon} bg-${this.props.color}`}></i>
        <div className="timeline-item">
          <span className="time">
            <i className="fa fa-clock-o"></i> {this.props.time}
          </span>
          <h3 className="timeline-header">{this.props.title}</h3>
          <div className="timeline-body">{this.props.content}</div>
        </div>
      </li>
    );
  }
}

module.exports = {
  Timeline,
  Separator,
  Item,
};
